import { t } from '@lingui/macro';
import { object, string } from 'yup';
const nameRequiredText = t({
    message: 'Name is required',
    comment: 'validation message when no data is provided for name field',
});
export const schema = object().shape({
    name: string().trim().required(nameRequiredText),
});
